import {ComponentProps, useMemo} from "react";
import {css, cx} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";
import {getRandomConsultant} from "@pg-rp/consultants";

const CONSULTANT_PHONE_NUMBER = "48 734440816";
const CONSULTANT_PHONE_HREF = `tel:+${CONSULTANT_PHONE_NUMBER.replace(/\D/g, "")}`;

interface IProps extends ComponentProps<"div"> {
    className?: string;
}

export const ConsultantBox = ({className, ...props}: IProps) => {
    const consultant = useMemo(() => getRandomConsultant(), []);

    return (
        <a className={consultantPhoneLinkStyle} href={CONSULTANT_PHONE_HREF}>
            <div className={cx(consultantBox, className)} {...props}>
                <Image imageClassName={consultantImageStyle} width="44" height="44" src={consultant.image.s72} alt={consultant.fullName} />

                <div className={consultantInfoStyle}>
                    <Text variant="body_copy_2" className={consultantNameStyle}>
                        {consultant.fullName}
                    </Text>

                    <Text variant="info_txt_2" color="var(--colors-gray-700)">
                        Konsultant mieszkaniowy
                    </Text>

                    <Text variant="info_txt_1" as="span" className={consultantPhoneStyle}>
                        {phoneNumberFormat(CONSULTANT_PHONE_NUMBER)}
                    </Text>
                </div>
            </div>
        </a>
    );
};

const consultantBox = css({
    borderRadius: 2,
    backgroundColor: "var(--colors-white)",
    display: "flex",
    flexDirection: "row",
    gap: 1,
    alignItems: "center",
    padding: 1.5,
    minWidth: 234
});

const consultantImageStyle = css({
    borderRadius: "100%"
});

const consultantInfoStyle = css({
    display: "flex",
    flexDirection: "column",
    minWidth: 0
});

const consultantNameStyle = css({
    whiteSpace: "nowrap"
});

const consultantPhoneLinkStyle = css({
    color: "var(--colors-secondary)",
    textDecoration: "none",
    whiteSpace: "nowrap",
    fontSize: 0,
    lineHeight: 1
});

const consultantPhoneStyle = css({
    pt: 1
});
import {ComponentProps, useMemo} from "react";
import {css, cx} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";
import {getRandomConsultant} from "@pg-rp/consultants";

const CONSULTANT_PHONE_NUMBER = "48 734440816";
const CONSULTANT_PHONE_HREF = `tel:+${CONSULTANT_PHONE_NUMBER.replace(/\D/g, "")}`;

interface IProps extends ComponentProps<"div"> {
    className?: string;
}

export const ConsultantBox = ({className, ...props}: IProps) => {
    const consultant = useMemo(() => getRandomConsultant(), []);

    return (
        <a className={consultantPhoneLinkStyle} href={CONSULTANT_PHONE_HREF}>
            <div className={cx(consultantBox, className)} {...props}>
                <Image imageClassName={consultantImageStyle} width="44" height="44" src={consultant.image.s72} alt={consultant.fullName} />

                <div className={consultantInfoStyle}>
                    <Text variant="body_copy_2" className={consultantNameStyle}>
                        {consultant.fullName}
                    </Text>

                    <Text variant="info_txt_2" color="var(--colors-gray-700)">
                        Konsultant mieszkaniowy
                    </Text>

                    <Text variant="info_txt_1" as="span" className={consultantPhoneStyle}>
                        {phoneNumberFormat(CONSULTANT_PHONE_NUMBER)}
                    </Text>
                </div>
            </div>
        </a>
    );
};

const consultantBox = css({
    borderRadius: 2,
    backgroundColor: "var(--colors-white)",
    display: "flex",
    flexDirection: "row",
    gap: 1,
    alignItems: "center",
    padding: 1.5,
    minWidth: 234
});

const consultantImageStyle = css({
    borderRadius: "100%"
});

const consultantInfoStyle = css({
    display: "flex",
    flexDirection: "column",
    minWidth: 0
});

const consultantNameStyle = css({
    whiteSpace: "nowrap"
});

const consultantPhoneLinkStyle = css({
    color: "var(--colors-secondary)",
    textDecoration: "none",
    whiteSpace: "nowrap",
    fontSize: 0,
    lineHeight: 1
});

const consultantPhoneStyle = css({
    pt: 1
});
